import { easeInOutQuad } from './easeInOutQuad';
import { prefersReducedMotion } from './prefersReducedMotion';
import {
  beginScrollAnimation,
  isScrollAnimationCurrent,
} from './scrollAnimationRegistry';

// JS tween of an element's scrollTop. A virtualized scroller re-renders (spacer
// height + content transform) while a row expands, which cancels the browser's
// native smooth scroll; assigning scrollTop every frame survives those re-renders.
export const animateScrollTop = (
  el: HTMLElement,
  to: number,
  durationMs: number,
  onDone?: () => void
): void => {
  const from = el.scrollTop;
  const change = to - from;
  const token = beginScrollAnimation(el);

  if (Math.abs(change) < 1 || prefersReducedMotion()) {
    el.scrollTop = to;
    onDone?.();
    return;
  }

  const startedAt = performance.now();
  const step = (now: number): void => {
    if (!isScrollAnimationCurrent(el, token)) return;
    const t = Math.min(1, (now - startedAt) / durationMs);
    el.scrollTop = from + change * easeInOutQuad(t);
    if (t < 1) {
      requestAnimationFrame(step);
      return;
    }
    onDone?.();
  };

  requestAnimationFrame(step);
};
